import { render } from "./payment_people.vue?vue&type=template&id=7f16b9b6&scoped=true"
import script from "./payment_people.vue?vue&type=script&lang=js"
export * from "./payment_people.vue?vue&type=script&lang=js"

import "./payment_people.vue?vue&type=style&index=0&id=7f16b9b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f16b9b6"]])

export default __exports__